import styled from 'styled-components';

export const DocumentInputWrapper = styled.div`
  display: flex;
  gap: 8px;
  width: 100%;

  .type-selector {
    min-width: 140px;
    flex: 0 0 auto;
  }

  .number-input {
    flex: 1;
  }

  .ant-form-item {
    margin-bottom: 0;
  }
`;
